import {useState} from 'react'
import {Colors, Texts} from 'appearance'
import Card from 'components/Display/Card'
import {IconButton, styled} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import NoteActions from './NoteActions'

const Note = ({note, onClickAdd, onEdit, onDelete, showAddButton}) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)

    const openNoteActions = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const closeNoteActions = () => {
        setAnchorEl(null)
    }

    return (
        <NoteWrapper key={note.ClientNoteKey}>
            <NoteContainer
                variant="outlined"
                contentStyle={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: 8,
                }}>
                <NoteText>{note.Note}</NoteText>
                <IconButton onClick={openNoteActions}>
                    <MoreVertIcon />
                </IconButton>
            </NoteContainer>
            {showAddButton && (
                <AddNoteButton onClick={onClickAdd}>
                    <AddIcon />
                </AddNoteButton>
            )}

            <NoteActions
                open={open}
                anchorEl={anchorEl}
                onDelete={onDelete}
                onEdit={onEdit}
                handleClose={closeNoteActions}
                note={note}
            />
        </NoteWrapper>
    )
}

export default Note

const NoteWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 24px;
`
const NoteText = styled(Texts.RegularText)``

const AddNoteButton = styled(IconButton)`
    background-color: ${Colors.YELLOW};
    &:hover {
        background-color: ${Colors.LIGHT_YELLOW};
    }
`

const NoteContainer = styled(Card)`
    height: fit-content;
    border-color: ${Colors.LIGHT_YELLOW};
    border-radius: 10px;
    width: 50%;
`
